export default __webpack_public_path__ + "static/media/facebook.ad3944f4.svg";